// extracted by mini-css-extract-plugin
module.exports = {"root-container":"layout_root-container__T23Rt","main-container":"layout_main-container__1VzxO"};